module.exports = __webpack_public_path__ + "static/media/ins-3.2a9928db.webp";